import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'residenciaOuOutro'
})
export class ResidenciaOuOutroPipe implements PipeTransform {

  transform(value: boolean | null | undefined): string {
    if (value === true) return 'residência';
    if (value === false) return 'outro endereço';
    return '-';
  }

}
